<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>{{ id ? "编辑商品" : "新增商品" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content" style="padding-top: 15px">
      <el-form ref="goodsForm" :model="goodsForm" :rules="rules" label-width="120px">
        <el-form-item label="积分商品：">
          <el-button @click="dialogGoodsSel = true" v-if="!confirmList.goodsImage"
            >选择商品</el-button
          >
          <img
            v-else
            :src="confirmList.goodsImage"
            alt=""
            style="width: 80px; height: 80px"
          />
        </el-form-item>
        <el-form-item label="商品规格：">
          <div>
            <div class="specification-header flex-row-between">
              <div class="width25" v-for="item in specificationList" :key="item.id">
                {{ item.name }}
              </div>
            </div>
            <div class="specification-body flex-row-between">
              <div class="width25">{{ confirmList.goodsName }}</div>
              <div class="width25">{{ confirmList.unit }}</div>
              <div class="width25">{{ confirmList.retailPrice }}</div>
              <div class="width25">{{ confirmList.totalStockCount }}</div>
              <div
                class="width25"
                v-show="confirmList.retailPrice"
                @click="deleteGoods"
                v-if="!id"
              >
                删除
              </div>
              <div class="width25" v-else></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="活动名称：" prop="activityName">
          <el-input
            v-model="goodsForm.activityName"
            placeholder="请输入活动名称"
            :maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="所需积分：" prop="price">
          <el-input
            v-model="goodsForm.score"
            :disabled="id ? true : false"
            type="number"
            @blur="priceBlur"
            placeholder="请输入所需积分"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序序号">
          <el-input
            v-model="goodsForm.indexNo"
            type="number"
            placeholder="请输入排序序号"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" prop="time">
          <el-date-picker
            v-model="goodsForm.time"
            @change="timeChange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="expireTimeOption"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <dialog-sel-goods
      :isShow="dialogGoodsSel"
      @hideSelGoods="hideSelGoods"
      @confirmSelGoods="confirmSelGoods"
    ></dialog-sel-goods>
  </div>
</template>

<script>
import { addOrUpdateActivity, getSingleActivityList } from "../api/index";
import dialogSelGoods from "@/components/dialogSelGoods.vue";
export default {
  data() {
    return {
      id: "",
      goodsForm: {
        activityName: "",
        score: "",
        time: "",
        startTime: "",
        endTime: "",
        indexNo: 1,
      },
      rules: {
        activityName: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
        score: [{ required: true, message: "请输入所需积分", trigger: "blur" }],
        time: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
      dialogGoodsSel: false,
      specificationList: [
        { name: "商品名称", id: 1 },
        { name: "商品单位", id: 2 },
        { name: "商品价格", id: 3 },
        { name: "库存", id: 4 },
        { name: "操作", id: 5 },
      ],
      confirmList: {},
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
    };
  },
  components: {
    dialogSelGoods,
  },
  beforeDestroy() {
    localStorage.removeItem("updateActivityId");
  },
  mounted() {
    this.id = localStorage.updateActivityId;
    console.log(this.id, "id");
    this.getSingleActivityList(this.id);
  },
  methods: {
    getSingleActivityList(activityId) {
      getSingleActivityList({
        activityId: activityId,
      }).then((res) => {
        if (res.code == 1) {
          this.goodsForm = res.data;
          this.$set(this.goodsForm, "time", [res.data.startTime, res.data.endTime]);
          this.confirmList = {
            goodsName: res.data.goodsName,
            goodsImage: res.data.goodsImage,
            valueContent: res.data.valueContent,
            retailPrice: res.data.retailPrice,
            goodsId: res.data.goodsId,
            productId: res.data.productId,
            unit: res.data.unit,
            totalStockCount: res.data.totalStockCount,
          };
        } else {
        }
      });
    },
    timeChange(val) {
      if (val) {
        console.log(val);
        this.goodsForm.startTime = val[0];
        this.goodsForm.endTime = val[1];
      }
    },
    priceBlur(e) {
      let value = e.target.value;
      if (value != "") {
        if (value.indexOf(".") > -1) {
          this.goodsForm.score = value.slice(0, value.indexOf(".") + 3);
        } else {
          this.goodsForm.score = value.toFixed(2);
        }
      }
    },
    submit() {
      console.log(this.goodsForm);
      // return
      if (!this.confirmList.goodsId) {
        this.$notify({
          title: "提示",
          message: "请选择商品",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      this.$refs.goodsForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        }
      });
      addOrUpdateActivity({
        activityId: this.id,
        goodsId: this.confirmList.goodsId,
        productId: this.confirmList.productId,
        activityType: 5,
        activityName: this.goodsForm.activityName,
        score: this.goodsForm.score,
        indexNo: this.goodsForm.indexNo,
        startTime: this.goodsForm.startTime,
        endTime: this.goodsForm.endTime,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: `${this.id ? "修改成功" : "新增成功"}`,
            type: "success",
            duration: 1000,
          });
          this.$router.push("/exchange");
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 1000,
          });
        }
      });
    },
    deleteGoods() {
      this.confirmList = {};
    },
    confirmSelGoods(confirmList) {
      this.hideSelGoods();
      this.confirmList = confirmList;
    },
    hideSelGoods() {
      this.dialogGoodsSel = false;
    },
  },
};
</script>

<style lang="less" scoped>
.flex-row-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.specification-header {
  width: 452px;
  height: 40px;
  background: #f8f8f8;
  padding: 0 10px;
  color: #606266;
  font-size: 12px;
}
.specification-body {
  width: 450px;
  height: auto;
  border: 1px solid #ececec;
  border-top: none;
  padding: 0 10px;
  line-height: 40px;
}
.width25 {
  width: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  box-sizing: border-box;
  &:last-child {
    cursor: pointer;
  }
}
</style>
